import { duplicateCheckMarketCooperation } from '@/api/common'

/* 联系方式验证 */
export const checkContactMode = function (rule: any, value: string, callBack: Function) {
    if (value === '') {
        callBack(new Error('联系方式不能为空'))
    }
    const reg = /^[^\u4e00-\u9fa5]+$/
    if (!reg.test(value)) {
        callBack(new Error('联系方式不能包含中文'))
    } else {
        callBack()
    }

}

/* 合作伙伴查重和验证 */
export const checkPartnerName = async function (rule: any, value: string, callBack: Function) {
    if (value) {
        const data: any = await duplicateCheckMarketCooperation(value)
        if (data.marketCooperation.length === 0) {
            callBack()
        } else {
            callBack(new Error('合作方名称已存在'))
        }
    } else {
        callBack(new Error('合作方名称不能为空'))
    }
}

/**
 * @desc 将每一个返佣范围转化成可比较的对象
 * @param {Object} obj 每一个返佣范围
 * @returns {Object} 返回一个转化后的对象
 * **/
 const conversionRatioItem = function (obj, index: number) {
    const newObj: { min: number; max: number; index: number } = { min: undefined, max: undefined, index }
    if (obj.endCondition && Number(obj.endNum)) {
        if (obj.startCondition.includes('大于')) {
            newObj.min = obj.startCondition === '大于' ? Number(obj.startNum) + 0.001 : Number(obj.startNum)
            newObj.max = obj.endCondition === '小于' ? Number(obj.endNum) - 0.001 : Number(obj.endNum)
        }
        if (obj.startCondition.includes('小于')) {
            newObj.max = obj.startCondition === '小于' ? Number(obj.startNum) - 0.001 : Number(obj.startNum)
            newObj.min = obj.endCondition === '大于' ? Number(obj.endNum) + 0.001 : Number(obj.endNum)
        }
    } else {
        if (obj.startCondition.includes('大于')) {
            newObj.min = obj.startCondition === '大于' ? Number(obj.startNum) + 0.001 : Number(obj.startNum)
            newObj.max = Infinity
        }
        if (obj.startCondition.includes('小于')) {
            newObj.max = obj.startCondition === '小于' ? Number(obj.startNum) - 0.001 : Number(obj.startNum)
            newObj.min = 0
        }
        if (obj.startCondition === '等于') {
            newObj.max = Number(obj.startNum) + 0.001
            newObj.min = Number(obj.startNum) - 0.001
        }
    }
    return newObj
}

// 阶梯返佣范围内部错误判定
export const ladderItemError = function (data): boolean[] {
    return data.map((item, index) => {
        const obj = conversionRatioItem(item, index)
        return obj.min < obj.max
    })
}

/* 阶梯返佣范围之间冲突验证 */
export const ladderRatioCheck = function (data) {
    const arr = data
        .map((item, index) => conversionRatioItem(item, index))
        .sort((a, b) => { return a.min - b.min })
    const newobj = arr.map((item, index) => {
        const obj = { bol: false, index1: undefined, index2: undefined }
        if (index > 0) {
            if (item.min > arr[index - 1].max === false) {
                obj.bol = true
                obj.index1 = index
                obj.index2 = index - 1
            }
        }
        return obj
    })
    return newobj
}

// 项目类型列表
export const souCoueTypeList = [
    { id: 1, name: '国外小组科研' },
    { id: 2, name: '国内1对1' },
    { id: 3, name: '国外1对1' },
    { id: 4, name: '名校实验室' },
    { id: 5, name: 'AI HUB' },
    { id: 6, name: '全球华人导师' },
    { id: 27, name: '博雅计划-在线' },
    { id: 30, name: 'IEPQ线上项目' },
    { id: 31, name: '竞赛' },
    { id: 32, name: '全球华人导师-香港' },
    {id: 38, name: '海外导师线下项目'},
    {id: 39, name: '国内导师线下项目'},
    {id: 40, name: '竞赛1v1'},
    {id: 42, name: 'IEPQ 1v1'},
    {id: 44, name: '全球华人导师-海外'},
    {id: 45, name: '企业导师远程实训'},
    {id: 47, name: '博雅计划-线下'},
    {id: 48, name: 'IEPQ 1v3'},
    {id: 49, name: '专业选修课'},
    {id: 50, name: 'IEPQ线下项目'},
    {id: 51, name: 'CERTIPORT认证课程'},
    {id: 52, name: '境外游学项目'},
    {id: 53, name: '竞赛线下（营地）'},
    {id: 54, name: '竞赛线下（研学）'},
]

// 表单验证
export const formRules = {
    // name: [{ required: true, validator: checkPartnerName }],
    name: [{ required: true, message: '合作方名称不能为空', trigger: 'blur' }],
    source: [{ required: true, message: '来源不能为空', trigger: 'change' }],
    types: [{ required: true, message: '合作伙伴类型不能为空', trigger: 'change' }],
    contact: [{ required: true, message: '机构联系人不能为空', trigger: 'blur' }],
    contactInfo: [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],
    contractType: [{ required: true, message: '请选择合同类型', trigger: 'change' }],
    signAt: [{ required: true, message: '请选择机构签约时间', trigger: 'change' }],
    city: [{required: true, message: '请选择机构所在城市', trigger: ['change', 'blur']}],
    // invoiceType: [{ required: true, message: '请选择开票类型', trigger: 'change' }],
    // invoiceTitle: [{ required: true, message: '开票抬头不能为空', trigger: 'blur' }],
    // invoiceCode: [{ required: true, message: '纳税识别号不能为空', trigger: 'blur' }],
    // invoiceBank: [{ required: true, message: '开票行不能为空', trigger: 'blur' }],
    // invoiceAccount: [{ required: true, message: '开票账号不能为空', trigger: 'blur' }],
    // invoiceAddress: [{ required: true, message: '开票地址不能为空', trigger: 'blur' }],
    // invoicePhone: [{ required: true, message: '电话不能为空', trigger: 'blur' }],
}
